<template>
<div>
    <div class="user" v-if="this.$store.state.user.role">
        <div class="usericons">
            <router-link to="/usersettings"><font-awesome-icon :icon="['fal', 'user-cog']"/></router-link>
            <font-awesome-icon @click="create" :icon="['fal', 'user-plus']" superuser/>
            <router-link to="/allusersettings" administrator><font-awesome-icon :icon="['fal', 'users']"/></router-link>
            <font-awesome-icon @click="logout" :icon="['fal', 'sign-out-alt']"/>
            <router-link to="/machinesettings" administrator><font-awesome-icon :icon="['fal', 'cog']"/></router-link>
        </div>
        <table>
            <td>
                <tr></tr>
                <div v-if="$store.state.user.img">
                    <img :src="$store.state.user.img" height="32" width="32">
                </div>
                <div v-else>
                    <td width="29"></td>     
                </div>
            </td>
            <td>
                <tr>
                    <td>Name:</td>
                    <td>{{$store.state.user.name}}</td>
                </tr>
                <tr>
                    <td>Role:</td>
                    <td>{{$store.state.user.role}}</td>
                </tr>
                <tr class="logoutwarning" v-if="remainingTime">
                    <td>Logout:</td>
                    <td>{{remainingTime}}</td>
                </tr>
            </td>
        </table>
        
    </div>
    <div class="user" v-else>
        Not logged in
    </div>
    <modal name="loginmodal" :clickToClose="false" width="420px" height="190px">
        <h1>Please log in to use accrolab</h1>
        <table @keydown.enter="login">
            <tr>
                <td>Username:</td><td><input v-model="user"></td>
            </tr>
            <tr>
                <td>Password:</td><td><input type="password" v-model="pass"></td>
            </tr>
            <tr>
                <td colspan="2"><button :disabled="!user || !pass" @click="login">Login</button></td>
            </tr>
        </table>
    </modal>
    <modal name="createmodal" width="560px" height="360px">
        <h1>Create user</h1>
        <table @keydown.enter="createUser">
            <td width="320px" >
                <tr>
                    <td>Username:</td><td><input v-model="user"></td>
                </tr>
                <tr>
                    <td>Prename:</td><td><input v-model="prename"></td>
                </tr>
                <tr>
                    <td>Surname:</td><td><input v-model="surname"></td>
                </tr>
                <tr>
                    <td>Email:</td><td><input v-model="email"></td>
                </tr>
                <tr>
                    <td>Password:</td><td><input type="password" :class='{valid:passwordValidation.valid}' v-model="pass"></td>
                </tr>
                <tr>
                    <td class="treeselect">Role:</td><td><treeselect v-model="role" :options="possibleRoles"/></td>
                </tr>
                <tr>    
                    <td colspan="2"><button :disabled="!user || !pass || !role || !prename || !surname || (passwordValidation.errors.length >0)" @click="createUser">Create</button></td>
                </tr>
            </td>
            <td width="20px"/>
            <td width="220px">
                <tr>Hints:</tr>
                <tr>
                    <transition name="hint" appear>
                        <div v-if='passwordValidation.errors.length > 0' class='hints'>
                            <p v-for='error in passwordValidation.errors'>{{error}}</p>
                        </div>
                    </transition>
                </tr>
            </td>
        </table>
    </modal>
</div>
</template>

<script>

export default {
    computed: {
        possibleRoles() {
            return this.$store.state.roles.filter((role, index)=>{
                return index <= this.$store.state.roles.indexOf(this.$store.state.user.role);
            }).map(role=>({id: role, label: role}))
        },
        passwordValidation () {
            let errors = []
            for (let condition of this.rules) {
                if (condition.setting) {
                    if (!condition.regex.test(this.pass)) {
                        errors.push(condition.message)
                    }
                }
            }
            if (!this.mailRegex.test(this.email)) {
                errors.push("+ valid email address required")
            }
            if (errors.length === 0) {
                return { valid:true, errors }
            } else {
                return { valid:false, errors }
            }
        },
    },
    methods: {
        login(){
            this.$api.compatibilityEmit('login', this.user, this.pass, (user, denyInfo)=>{
                if(user){
                    this.$set(this.$store.state, 'user', user);
                    this.$modal.hide('loginmodal');
                    const passDays = this.$store.state.user.passValidDays - ((Date.now() - this.$store.state.user.passCreateDate)/(1000*60*60*24)).toFixed(0);
                    if (passDays <= 14) {
                        this.$modal.show('dialog', {
                            title: 'Your password expires in ' + passDays + ' days. Please create a new password.',
                            buttons: [
                                {
                                  title: 'OK'
                                }
                            ]
                        })
                    }
                }
                else{
                    let titleText = this.denyTitle[denyInfo.indexOf(false)];
                    if(titleText == '')
                    {
                        titleText = this.denyTitle[3];
                    }
                    console.log(titleText);
                    this.$modal.show('dialog', {
                        title: titleText,
                        buttons: [
                            {
                              title: 'Close'
                            }
                        ]
                    })
                }
                this.user    = '';
                this.pass    = '';
                this.prename = '';
                this.surname = '';
                this.email   = '';
            });
        },
        logout(){
            this.$api.compatibilityEmit('logout');
            this.$store.state.user.role = null;
            this.user    = '';
            this.pass    = '';
            this.prename = '';
            this.surname = '';
            this.email   = '';
            this.$modal.show('loginmodal');
            this.$router.push('/sequencetable');
        },
        create(){
            this.user    = '';
            this.pass    = '';
            this.prename = '';
            this.surname = '';
            this.email   = '';
            this.$api.compatibilityEmit('userMaxLimit', (ok)=>{
                if (ok) {
                    this.$modal.show('createmodal');
                }
                else{
                    this.$modal.show('dialog', {
                        title: 'Maximum active user limit reached',
                        buttons: [
                            {
                              title: 'Close'
                            }
                        ]
                    })
                }  
            });
        },
        createUser(){
            this.$modal.hide('createmodal');
            this.$api.compatibilityEmit('createUser', this.user.trim(), this.prename.trim(), this.surname.trim(), this.email, this.pass, this.role, (ok)=>{
                this.$modal.hide('changemodal');
                this.$modal.show('dialog', {
                    title: ok?'User added':'Could not add user. User name or email address already exists.',
                    buttons: [
                        {
                          title: 'Close'
                        }
                    ]
                })
            });
        },
    },
    components: {
        
    },
    watch: {
        '$store.state.user.role'(){
            if(this.$store.state.user.role){
                this.$modal.hide('loginmodal');
            }else{
                this.$modal.show('loginmodal');
            }
        }
    },
    mounted(){
        if(!this.$store.state.user.role){
            this.$modal.show('loginmodal');
        }
        document.addEventListener('click', ()=>{
            this.lastClick = Date.now()
        });
        setInterval(()=>{
            const elapsed = Date.now()-this.lastClick;
            if(elapsed > this.$store.state.user.logoutTime - 2*60*1000){
                const remaining = this.$store.state.user.logoutTime - elapsed;
                this.remainingTime = `${Math.floor(remaining/1000/60)}:${String(Math.floor(remaining/1000)%60).padStart(2, '0')}`;
                if(remaining <= 0 && this.$store.state.user.role){
                    this.logout();
                }
            }else{
                this.remainingTime = null;
            }
        }, 1000)
    },
    props: [
        
    ],
    data: function(){
        return {
            user: '',
            pass: '',
            prename: '',
            surname: '',
            email: '',
            role: 'operator',
            lastClick: Date.now(),
            remainingTime: null,
            rules: [
                { message: '+ One lowercase letter required.',
                  regex:   /[a-z]+/, 
                  setting: this.$store.state.machineSettings.password.lowerLetter},
                { message: "+ One uppercase letter required.",
                  regex:   /[A-Z]+/,
                  setting: this.$store.state.machineSettings.password.upperLetter},
                { message: "+ " + this.$store.state.machineSettings.password.wordLength + " characters minimum.",
                  regex:   new RegExp(".{" + this.$store.state.machineSettings.password.wordLength + ",}"),
                  setting: true},
                { message: "+ One number required.",
                  regex:   /[0-9]+/,
                  setting: this.$store.state.machineSettings.password.numberLetter},
                { message: "+ One special character required.",
                  regex:   /[\W_]+/, 
                  setting: this.$store.state.machineSettings.password.specialLetter}
            ],
            denyTitle: ["password incorrect", "user not activated", "password expired. Please inform your administrator", "user unknown"],
            mailRegex: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        }
    }
}

</script>

<style>
    .overflowvisible {
        overflow: visible !important;
    }
</style>

<style lang="scss" scoped>
    @import "../colors.scss";
    .user {
        padding-right: 15px;
        padding-top: 29px;
        font-size: 1rem;
        text-align: right;
        .usericons {
            font-size: 1.5rem;
            svg {
                margin-left: 5px;
                &:hover {
                    color: $accromablue;
                }
            }
        }
        img {
            border-radius: 50%;
            margin: 3px;
        }
        table {
            text-align: left;
            float: right;
            width: 65%;
        }
        .logoutwarning {
            color: red;
        }
    }
    .treeselect{
        vertical-align: middle;
    }

    .hints {
        p {
            margin: 0;
            font-size: 1.1rem;
        }
    }
</style>
